import React from 'react';
import clsx from 'clsx';
import useStyles from './styles';

type Props = {
  center?: boolean;
  children: React.ReactNode;
};

const PricingPageTableHeader = ({ children, center = false }: Props) => {

  const classes = useStyles();

  return (
    <div className={clsx(classes.container, {
      [classes.containerCentered]: center,
    })}
    >
      {children}
    </div>
  );
};

export default PricingPageTableHeader;
